import React from 'react';
import styled from 'styled-components';

import {
  FacebookShareButton,
  LinkedinShareButton,
  TwitterShareButton,
  EmailShareButton,
  FacebookIcon,
  LinkedinIcon,
  TwitterIcon,
  EmailIcon,
} from 'react-share';

import CopyUrlSVG from '@style-guide/svg/CopyUrlSVG';

const ShareItem = styled.li`
  cursor: pointer;
`;

ShareItem.displayName = 'ShareItem';

const ShareLabel = styled.span`
  font-weight: 500;
  margin-right: 10px;
`;

ShareLabel.displayName = 'ShareLabel';

const SocialShareContainer = styled.ul`
  align-items: center;
  display: flex;
  justify-content: flex-start;

  > *:not(:last-child) {
    margin-right: 5px;
  }
`;

SocialShareContainer.displayName = 'SocialShareContainer';

function copy() {
  const el = document.createElement('input');
  el.value = window.location.href;
  document.body.appendChild(el);
  el.select();
  document.execCommand('copy');
  document.body.removeChild(el);
}

const SocialShare = () => {
  const shareUrl = window.location.href || document.location.href;
  const articleTitle = document.title;

  return (
    <SocialShareContainer>
      <li>
        <ShareLabel>Share</ShareLabel>
      </li>
      <ShareItem>
        <LinkedinShareButton
          title={articleTitle}
          url={shareUrl}
        >
          <LinkedinIcon
            size={32}
            round
          />
        </LinkedinShareButton>
      </ShareItem>
      <ShareItem>
        <FacebookShareButton
          url={shareUrl}
        >
          <FacebookIcon
            size={32}
            round
          />
        </FacebookShareButton>
      </ShareItem>
      <ShareItem>
        <TwitterShareButton
          title={articleTitle}
          url={shareUrl}
        >
          <TwitterIcon
            size={32}
            round
          />
        </TwitterShareButton>
      </ShareItem>
      <ShareItem>
        <EmailShareButton
          subject={articleTitle}
          url={shareUrl}
        >
          <EmailIcon
            size={32}
            round
          />
        </EmailShareButton>
      </ShareItem>
      <ShareItem>
        <button type="button" style={{ padding: '0px' }} onClick={copy}>
          <CopyUrlSVG height="40px" color="#a41f35" />
        </button>
      </ShareItem>
    </SocialShareContainer>
  );
};

SocialShare.displayName = 'SocialShare';

export default SocialShare;
